import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Pricing from './pages/Pricing'
import Profile from './pages/Profile'
import Gallery from './pages/Gallery'
import GalleryDetail from './pages/GalleryDetail'
import UserProfile from './pages/UserProfile'
import Admin from './pages/Admin'

export default function App() {
  return (
    <div className="min-h-screen bg-cream-50 text-cocoa">
      <Navbar />
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/share/:code" element={<GalleryDetail />} />
          <Route path="/gallery/:id" element={<GalleryDetail />} />
          <Route path="/user/:id" element={<UserProfile />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  )
}
